import { Link, NavLink, useNavigate } from "react-router-dom";
import { Radio, LogOut, LayoutGrid, History, Settings2, BarChart3 } from "lucide-react";
import { clearToken } from "@/lib/adminApi";

const items = [
  { to: "/admin/artwork", label: "Validation", icon: LayoutGrid, end: false },
  { to: "/admin/history", label: "Historique", icon: History, end: false },
  { to: "/admin/radios", label: "Radios", icon: Settings2, end: false },
  { to: "/admin/analytics", label: "Statistiques", icon: BarChart3, end: false },
];

export function AdminHeader() {
  const nav = useNavigate();
  const onLogout = () => {
    clearToken();
    nav("/admin/login");
  };
  return (
    <header className="mw-header" data-testid="admin-header">
      <div className="mw-header-inner">
        <Link to="/admin/artwork" className="mw-brand">
          <span className="mw-brand-mark" aria-hidden="true">
            <Radio size={18} strokeWidth={2.2} />
          </span>
          <span className="mw-brand-text">
            <span className="mw-brand-name">Admin</span>
            <span className="mw-brand-name mw-brand-name-accent">Central</span>
          </span>
        </Link>

        <nav className="mw-nav admin-nav">
          {items.map(({ to, label, icon: Icon, end }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              className={({ isActive }) =>
                isActive ? "mw-nav-link mw-nav-link-active" : "mw-nav-link"
              }
            >
              <Icon size={14} style={{ marginRight: 6, marginBottom: -2 }} />
              {label}
            </NavLink>
          ))}
          <button
            type="button"
            className="mw-nav-link admin-logout"
            onClick={onLogout}
            data-testid="admin-logout"
          >
            <LogOut size={14} style={{ marginRight: 6, marginBottom: -2 }} />
            Quitter
          </button>
        </nav>
      </div>
    </header>
  );
}
